import { useEffect, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import ReactPaginate from "react-paginate";
import { useWPAjaxQuery } from "../../../../utils/hooks";

const APP = () => {
  const [tab, setTab] = useState("all");
  const [feedbacks, setFeedbacks] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { data, isLoading } = useWPAjaxQuery(bData.ajaxURL, {
    method: "getFeedbacks",
    action: "vstr_ajax",
    token: bData.nonce,
  });

  useEffect(() => {
    const date = new Date();
    const today = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`;
    if (tab === "all") {
      setFeedbacks(data?.filter((item) => !item.feedback?.includes("Popup viewed") && !item.feedback?.includes("Popup closed")));
    }
    if (tab === "today-viewed") {
      setFeedbacks(data.filter((item) => item.created_at?.includes(today) && item.feedback?.includes("Popup viewed")));
    }
    if (tab === "today") {
      setFeedbacks(data.filter((item) => item.created_at?.includes(today) && !item.feedback?.includes("Popup viewed") && !item.feedback?.includes("Popup closed")));
    }
    if (tab === "today-closed") {
      setFeedbacks(data.filter((item) => item.created_at?.includes(today) && item.feedback?.includes("Popup closed")));
    }
  }, [tab, isLoading]);

  function Items({ currentItems }) {
    return (
      <>
        {currentItems &&
          currentItems.map((item, index) => (
            <tr key={index} className="item">
              <td>{item.feedback}</td>
              <td>{item.created_at}</td>
            </tr>
          ))}
      </>
    );
  }

  function PaginatedItems({ itemsPerPage }) {
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = feedbacks.slice(itemOffset, endOffset).sort((a, b) => b.id - a.id);
    const pageCount = Math.ceil(feedbacks.length / itemsPerPage);

    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % feedbacks.length;
      setItemOffset(newOffset);
    };

    return (
      <>
        <table className="items">
          <thead>
            <tr>
              <th width="70%">{__("Feedback", "visitor-feedback")}</th>
              <th>{__("Created at", "visitor-feedback")}</th>
            </tr>
          </thead>
          <tbody>
            {feedbacks?.length ? (
              <Items currentItems={currentItems} />
            ) : (
              <tr>
                <td className="text-center" colSpan={2}>
                  {!isLoading && <h3>{__("No Data Available", "visitor-feedback")}</h3>}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <ReactPaginate breakLabel="..." nextLabel=">" onPageChange={handlePageClick} pageRangeDisplayed={5} pageCount={pageCount} previousLabel="<" renderOnZeroPageCount={null} />
      </>
    );
  }

  return (
    <>
      <div className="vstr_feedbacks">
        <ul className="tabs">
          <li className={tab === "all" ? "active" : ""} onClick={() => setTab("all")}>
            {__("All", "visitor-feedback")}
          </li>
          <li className={tab === "today" ? "active" : ""} onClick={() => setTab("today")}>
            {__("Today", "visitor-feedback")}
          </li>
          <li className={tab === "today-viewed" ? "active" : ""} onClick={() => setTab("today-viewed")}>
            {__("Today Viewed", "visitor-feedback")}
          </li>
          <li className={tab === "today-closed" ? "active" : ""} onClick={() => setTab("today-closed")}>
            {__("Today Closed", "visitor-feedback")}
          </li>
        </ul>
      </div>
      {feedbacks && <PaginatedItems itemsPerPage={itemsPerPage} />}
    </>
  );
};

export default APP;
